<template>
  <div
    class="info-box"
    :class="[{ 'info-box--active': active }, { 'info-box--menu': inMenu }]"
    ref="infobox"
    @click="active = !active"
  >
    <fa class="info-box__btn" :icon="['fa', 'info-circle']" />
    <div
      class="info-box__modal"
      ref="modal"
      :style="`left: ${leftOffset}px`"
      @click.stop
    >
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "info-box",

  props: {
    inMenu: {
      type: Boolean,
      default: false
    },
    leftOffset: {
      type: Number,
      default: -15
    }
  },

  data() {
    return {
      active: false
    };
  },

  methods: {
    toggle() {
      this.active = !this.active;
    },

    handleClickOutside(event) {
      const box = this.$refs.infobox;
      if (!box) return;

      // if click is outside the info-box, close it
      if (!box.contains(event.target)) {
        this.active = false;
      }
    }
  },

  mounted() {
    const infoboxEl = this.$refs.infobox;
    const infoboxModalEl = this.$refs.infobox.querySelector(".info-box__modal");
    const taginfoEl = infoboxEl.closest(".tag-info");

    if (taginfoEl) {
      const offsetLeft = 20 - infoboxEl.offsetLeft;
      const modalWidth = taginfoEl.clientWidth - 40;

      infoboxModalEl.style.left = `${offsetLeft}px`;
      infoboxModalEl.style.width = `${modalWidth}px`;
    }

    // NEW: click-outside listener
    document.addEventListener("click", this.handleClickOutside);
  },

  beforeDestroy() {
    document.removeEventListener("click", this.handleClickOutside);
  }
};
</script>

<style lang="scss">
.info-box {
  color: #ddd;
  cursor: pointer;
  display: inline-block;
  position: relative;

  &:hover,
  &--active {
    color: #9bbac4;

    .info-box__modal {
      opacity: 1;
      pointer-events: auto;
    }
  }

  &--menu {
    .info-box__modal {
      max-width: 250px;
    }
  }

  &__btn {
    font-size: 16px !important;
  }

  &__modal {
    background: #fff;
    border-radius: 4px;
    box-shadow: 0 0px 2.2px rgba(0, 0, 0, 0.028),
      0 0px 5.3px rgba(0, 0, 0, 0.04), 0 0px 10px rgba(0, 0, 0, 0.05),
      0 0px 17.9px rgba(0, 0, 0, 0.06), 0 0px 33.4px rgba(0, 0, 0, 0.072),
      0 0px 80px rgba(0, 0, 0, 0.1);
    color: #222;
    cursor: initial;
    font-size: 14px;
    left: -15px;
    position: absolute;
    padding: 15px 20px;
    top: 23px;
    width: 360px;
    z-index: 11000;
    opacity: 0;
    pointer-events: none;
    text-transform: initial;
    transition: opacity 0.3s;

    &::before {
      content: none;
      width: 0;
      height: 0;
      border-left: 11px solid transparent;
      border-right: 11px solid transparent;
      border-bottom: 15px solid #fff;
      left: 12px;
      position: absolute;
      top: -15px;
    }

    p,
    li {
      line-height: 1.3;
      margin-bottom: 0.5em;
    }

    p:last-of-type {
      margin-bottom: 0;
    }

    ul {
      margin: 0;
      padding: 0 15px;
    }
  }
}
</style>
